export default [
  [`Размеры`, `2XS`, `XS`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `40`, `42`, `44`, `46`, `48`, `50`, `52`],
  [`Рост`, `164`, `164`, `170`, `170`, `170`, `170`, `170`],
  [`Обхват груди(a)`, `80`, `84`, `88`, `92`, `96`, `100`, `104`],
  [`Обхват бедер (b)`, `86`, `90`, `94`, `98`, `102`, `106`, `110`],
  [`Длин юбки (c)`, `62`, `62`, `64`, `64`, `64`, `66`, `66`],
  [`Ширина талии (d)`, `31`, `33`, `35`, `37`, `39`, `41`, `43`],
  [`Ширина бёдер (e)`, `42`, `44`, `46`, `48`, `50`, `52`, `54`],
  [`Ширина низа (f)`, `37`, `39`, `41`, `43`, `45`, `47`, `49`]
];
